export const PlusCircleFilledIcon = () => (
  <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12.5 22C6.97967 21.9939 2.50606 17.5203 2.5 12V11.8C2.60993 6.30452 7.13459 1.92794 12.6307 2.00087C18.1268 2.07379 22.5337 6.56887 22.4978 12.0653C22.4619 17.5618 17.9966 21.9989 12.5 22ZM7.5 11V13H11.5V17H13.5V13H17.5V11H13.5V6.99999H11.5V11H7.5Z'
      fill='currentColor'
    />
  </svg>
)

export const PlusIcon = () => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M16.0005 2V30' stroke='currentColor' strokeWidth='4' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M2 15.9998L30 15.9998' stroke='currentColor' strokeWidth='4' strokeLinecap='round'
          strokeLinejoin='round' />
  </svg>

)
